import { AuthorizeGoogleUserMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation

   onHandleError: (
      errorMessage: string,
      data: Mutation['authorizeGoogleUser']
   ) => void

   onSuccess: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      const { authorizeGoogleUser } = args.data

      switch (authorizeGoogleUser.__typename) {
         case 'AuthorizeGoogleUserResult': {
            const { isAuthorized } = authorizeGoogleUser
            if (!isAuthorized) break
            args.onSuccess()
            break
         }
         case 'InvalidAuthorizationCode':
         default: {
            const errorType = authorizeGoogleUser.__typename
            const errorMessage = errorType
               ? errorType.replace(/([A-Z])/g, ' $1')
               : 'Unhandled Error Type'

            args.onHandleError?.(errorMessage, authorizeGoogleUser)
         }
      }
   }

   return { handleAPIResponse }
}

export default useResponseHandler
